export default function getZodiacColor(zodiac, isPrev, isNext) {
  const zodiacType = zodiac.type
  let type = ''

  if (isPrev) {
     if (zodiacType === 'Root') {type = 'Fruit'} //need the previous color
     if (zodiacType === 'Flower') {type = 'Root'} //need the previous color
     if (zodiacType === 'Leaf') {type = 'Flower'} //need the previous color
     if (zodiacType === 'Fruit') {type = 'Leaf'} //need the previous color
  }
  else if (isNext) {
     if (zodiacType === 'Root') {type = 'Flower'} //need the next color
     if (zodiacType === 'Flower') {type = 'Leaf'} //need the next color
     if (zodiacType === 'Leaf') {type = 'Fruit'} //need the next color
     if (zodiacType === 'Fruit') {type = 'Root'} //need the next color
  }
  else {
    type = zodiac.type
  }
    const colors = {
      'Root': 'bg-stone-300',
      'Flower': 'bg-yellow-400 ',
      'Leaf': 'bg-green-400',
      'Fruit': 'bg-red-400'
    };
      return colors[type] ;
  };

/*

  if (zodiacType === 'Root') {
    if (zodiac.degreeInSign > 22.5 && zodiac.degreeInSign < 27 ) {
      return `bg-gradient-to-r from-stone-300 from-${Math.ceil(zodiac.degreeInSign  / 30 * 100 / 10) * 10 }% via-stone-300 via-${Math.ceil(zodiac.degreeInSign  / 30 * 100 / 10) * 10 }% to-yellow-100 to-${Math.ceil(zodiac.degreeInSign  / 30 * 100 / 10) * 10 }%`
    }else if (zodiac.degreeInSign < 5 ) {
     // return `bg-gradient-to-r from-stone-300 from-${Math.floor(zodiac.degreeInSign)}% via-stone-300 via-${Math.floor(zodiac.degreeInSign)}% to-yellow-100 to-100%`
    }else {
        return 'bg-stone-300'

    }
  }

  if (zodiacType === 'Flower') {
    if (zodiac.degreeInSign > 22.5 && zodiac.degreeInSign < 27 ) {
      return `bg-gradient-to-r from-yellow-100 from-${Math.ceil(zodiac.degreeInSign  / 30 * 100 / 10) * 10 }% via-yellow-100 via-${Math.ceil(zodiac.degreeInSign  / 30 * 100 / 10) * 10 }% to-green-100 to-${Math.ceil(zodiac.degreeInSign  / 30 * 100 / 10) * 10 }%`
    }else if (zodiac.degreeInSign < 5 ) {
     // return `bg-gradient-to-r from-stone-300 from-${Math.floor(zodiac.degreeInSign)}% via-stone-300 via-${Math.floor(zodiac.degreeInSign)}% to-yellow-100 to-100%`
    }else {
        return 'bg-yellow-100'
    }
  }



  if (zodiacType === 'Leaf') {
     if (zodiac.degreeInSign > 22.5 && zodiac.degreeInSign < 27 ) {
      return `bg-gradient-to-r from-green-100 from-${Math.ceil(zodiac.degreeInSign  / 30 * 100 / 10) * 10 }% via-green-100 via-${Math.ceil(zodiac.degreeInSign  / 30 * 100 / 10) * 10 }% to-red-100 to-${Math.ceil(zodiac.degreeInSign  / 30 * 100 / 10) * 10 }%`
    }else if (zodiac.degreeInSign < 5 ) {
     // return `bg-gradient-to-r from-stone-300 from-${Math.floor(zodiac.degreeInSign)}% via-stone-300 via-${Math.floor(zodiac.degreeInSign)}% to-yellow-100 to-100%`
    }else {
        return 'bg-green-100'
    }
  }



  if (zodiacType === 'Fruit') {
     if (zodiac.degreeInSign > 22.5 && zodiac.degreeInSign < 27 ) {
      return `bg-gradient-to-r from-red-100 from-${Math.ceil(zodiac.degreeInSign  / 30 * 100 / 10) * 10 }% via-red-100 via-${Math.ceil(zodiac.degreeInSign  / 30 * 100 / 10) * 10 }% to-stone-300 to-${Math.ceil(zodiac.degreeInSign  / 30 * 100 / 10) * 10 }%`
    }else if (zodiac.degreeInSign < 5 ) {
     // return `bg-gradient-to-r from-stone-300 from-${Math.floor(zodiac.degreeInSign)}% via-stone-300 via-${Math.floor(zodiac.degreeInSign)}% to-yellow-100 to-100%`
    }else {
        return 'bg-red-100'
    }
  }



};


  */